export const HEADER_ZINDEX = 1000;
export const HEADER_DROPDOWN_ZINDEX = 1001;
export const MODAL_ZINDEX = 10000;
export const LOADINGSPINNER_ZINDEX = 30000;
export const CALENDER_MODAL_ZINDEX = 1300;
export const LOADING_SCREEN_ZINDEX = 1900;
export const HEADER_LANGUAGE_MODAL_ZINDEX = 1300;
export const MAINTENANCE_SCREEN_ZINDEX = 1800;
export const FOOTER_LOGO_ZINDEX = 600;
